import { defineComponent } from 'vue';
import EmbeddedDashboard from '@/presentation/components/embedded-dashboard/embedded-dashboard.vue';
import SelectedDashboardCode from '@/presentation/pages/selected-dashboard/selected-dashboard.code';

export default defineComponent({
	components: {
		EmbeddedDashboard
	},
	setup: () => {
		const code = new SelectedDashboardCode();

		return {
			goToOverview: code.goToOverview.bind(code)
		};
	}
});
